import React from "react";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import {getIsUSCAMXUser, getJsonState, getUserCommsBankTerms} from "modules/selectors";
import {SectionTitle, SectionContent, SectionWrapper} from "./common";
import {PROJECT_NAME, ProjectName} from "modules";
import {Exist} from "components/Exist";
import {get} from "lodash";

export const Prizes: React.FC = () => {
	const {t, i18n} = useTranslation();
	const {helpPages} = useSelector(getJsonState);
	const commsBankTerms = useSelector(getUserCommsBankTerms);
	const isUSCAMXUser = useSelector(getIsUSCAMXUser);
	const isDailyFantasy = PROJECT_NAME === ProjectName.FantasyDaily;
	const isFancestry = PROJECT_NAME === ProjectName.FancestryQuiz;
	const showCommsBank = commsBankTerms && isDailyFantasy;
	const showGeico = isUSCAMXUser && isFancestry;

	if (!helpPages) {
		return null;
	}

	const data = helpPages.prizes?.find((prize) => prize.lang === i18n.language);
	const commsBank = helpPages.comms_bank_prizes?.find((prize) => prize.lang === i18n.language);
	const geico = helpPages.geico_fancestry?.find((term) => term.lang === i18n.language);

	return (
		<SectionWrapper>
			<SectionTitle>{t("help.fifa.prizes")}</SectionTitle>
			<SectionContent dangerouslySetInnerHTML={{__html: get(data, "text", "")}} />
			<Exist when={showCommsBank}>
				<SectionTitle dangerouslySetInnerHTML={{__html: get(commsBank, "title", "")}} />
				<SectionContent dangerouslySetInnerHTML={{__html: get(commsBank, "text", "")}} />
			</Exist>
			<Exist when={showGeico}>
				<SectionTitle dangerouslySetInnerHTML={{__html: get(geico, "title", "")}} />
				<SectionContent dangerouslySetInnerHTML={{__html: get(geico, "text", "")}} />
			</Exist>
		</SectionWrapper>
	);
};
